import type { TFunction } from "i18next"
import { formatMoneyFromMicrounits, formatMoneyWhole, formatRubFromMicrounits } from "@/lib/billing-format"

/** Остаток валютных счетов: рядом с рублями, не в сумме с ними (docs/billing_currency_accounts.md). */
export type CompanyCurrencyBalance = {
  currency: string
  balance_microcents: number
  held_microcents: number
  available_microcents: number
}

/** Верхние поля — рублёвые счета; currencies — валютные, по строке на валюту. */
export type CompanyBalanceShare = {
  balance_microcents: number
  held_microcents: number
  available_microcents: number
  accounts_count: number
  can_top_up: boolean
  currencies?: CompanyCurrencyBalance[]
}

/** Короткая строка валютных остатков для меню: «$120 · €40». */
export function foreignBalancesShort(balance: CompanyBalanceShare): string | null {
  const rows = balance.currencies ?? []
  if (rows.length === 0) return null
  return rows.map((row) => formatMoneyWhole(row.available_microcents, row.currency)).join(" · ")
}

export const COMPANY_TOP_UP_HREF = "/company/billing?topup=1"

export function companyBalanceTitle(t: TFunction<"billing">, balance: CompanyBalanceShare): string {
  return [
    `${t("client.balance")} ${formatRubFromMicrounits(balance.available_microcents)}`,
    balance.held_microcents > 0
      ? t("client.availableBreakdown", {
          balance: formatRubFromMicrounits(balance.balance_microcents),
          held: formatRubFromMicrounits(balance.held_microcents),
        })
      : null,
    ...(balance.currencies ?? []).map(
      (row) => `${row.currency} ${formatMoneyFromMicrounits(row.available_microcents, row.currency)}`,
    ),
  ]
    .filter(Boolean)
    .join(" · ")
}
